import { Converter } from '../types/converter';

export const numbersConverter: Converter = {
  id: 'numbers',
  name: 'Numbers Converter',
  icon: 'Hash',
  categories: ['common'],
  units: [
    // Number bases
    { name: 'Decimal (Base 10)', symbol: 'dec', factor: 1 },
    { name: 'Binary (Base 2)', symbol: 'bin', factor: 1 },
    { name: 'Octal (Base 8)', symbol: 'oct', factor: 1 },
    { name: 'Hexadecimal (Base 16)', symbol: 'hex', factor: 1 },
    { name: 'Base 32', symbol: 'b32', factor: 1 },
    { name: 'Base 36', symbol: 'b36', factor: 1 },
    { name: 'Base 58', symbol: 'b58', factor: 1 },
    { name: 'Base 64', symbol: 'b64', factor: 1 },
    
    // Roman numerals
    { name: 'Roman numerals', symbol: 'roman', factor: 1 },
    
    // Scientific notation
    { name: 'Scientific notation', symbol: 'sci', factor: 1 },
    { name: 'Engineering notation', symbol: 'eng', factor: 1 },
    
    // Other
    { name: 'Words', symbol: 'words', factor: 1 },
    { name: 'Ordinal', symbol: 'ord', factor: 1 }
  ]
};
